// src/utils/bannerService.js
import { db } from "../firebase";
import { uploadToCloudinary } from "./cloudinaryUpload";

const bannerCollection = db.collection("banners");

// add banner
export const addBanner = async (file, extraData) => {
  try {
    // upload file ke Cloudinary
    const { imageUrl, namaBanner } = await uploadToCloudinary(file);

    // simpan ke Firebase
    const docRef = await db.collection("banner").add({
      ...extraData,
      imageUrl,
      namaBanner,
      dateCreated: new Date(),
    });

    return docRef.id;
  } catch (err) {
    console.error("Add banner error:", err);
    throw err;
  }
};

// Get semua banner
export const getBanners = async () => {
  const snapshot = await bannerCollection.orderBy("position").get();
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

// Update banner
export const updateBanner = async (id, data) => {
  await bannerCollection.doc(id).update(data);
};

// Delete banner
export const deleteBanner = async (id) => {
  await bannerCollection.doc(id).delete();
};
